import { getWsjCommercialWhatsappUrl } from '@/lib/wsjCommercialWhatsapp';

export function buildDigitalInviteOrderMessage(modelName) {
  return `Olá, quero encomendar um convite digital. Tenho interesse no modelo: ${modelName}.`;
}

export function buildDigitalInviteViewModelMessage(modelName) {
  return `Olá, gostaria de ver exemplos do modelo: ${modelName}.`;
}

export function getDigitalInviteOrderWhatsappUrl(modelName) {
  return getWsjCommercialWhatsappUrl(buildDigitalInviteOrderMessage(modelName));
}

export function getDigitalInviteViewModelWhatsappUrl(modelName) {
  return getWsjCommercialWhatsappUrl(buildDigitalInviteViewModelMessage(modelName));
}
